export default __webpack_public_path__ + "static/icecream-taste-2-desktop-55a6d7084e511e77b6c51c640a71da55.png";